if ($('[data-component="offersqrcode"]').length) {
    (function () {
        loadOffersPage();
    })();

    function loadOffersPage() {
        subwayScript.showSpinner();
        var $fromOffersQRCode = $("#frmOffersQRCode");
        $.ajax({
            url: $fromOffersQRCode[0].action,
            type: 'POST',
            data: $fromOffersQRCode.serialize(),
            success: function (response) {
                $('[data-component="offersqrcode"]').html(response);
                subwayScript.hideSpinner();
                var hiddenValue = $($.parseHTML(response))
                var storeId = subwayScript.checkSatelliteNumber(hiddenValue.find("#hdnStoreId").val());
                var offerId = hiddenValue.find("#hdnOfferId").val();
                var offerDescription = hiddenValue.find('#hdnOfferDescription').val();
                var OfferTitle = hiddenValue.find("#hdnOfferTitle").val();
                var offertype = hiddenValue.find('#hdnOfferType').val();
                var countryLang = getDomainName()+$("#dtmPageName").val();
                const storeArray = countryLang.split(":");
                const storeLanguage = storeArray[1].split('-')[0];
                const storeCountry = storeArray[1].split('-')[1];
                analytics.offerCodePageLoad(OfferTitle, offerDescription, offerId, storeId, storeCountry, storeLanguage, offertype, countryLang);
            },
            error: function (jqXhr) {
                subwayScript.showAjaxError(jqXhr);
            }
        })
    }
}


function applyQROffer() {
    var {
        storeId, offerCode, offercampaignuri, offerExpirationDate, offerId, offertype, offerDescription, OfferTitle, countryLang
    } = getValues();

    var link = 'start order';
    var startOnlineOrder = 1;
    analytics.offerStart(offerId, offertype, offerDescription, OfferTitle, countryLang, link, startOnlineOrder);

    var actionLink = $('#hdnactionLink').val();

    subwayScript.showSpinner();

    if (storeId != 0 && storeId != '') {
        orderViewModel.store.id = subwayScript.checkSatelliteNumber(storeId);
        orderViewModel.save();
    }
    var currentStore = orderViewModel.store && orderViewModel.store.id || 0;
    var offerData = {
        offerId: offerId,
        propositionGuid: offerCode,
        offerCampaignUri: offercampaignuri,
        offerType: offertype,
        offerDescription: offerDescription,
        rewardExpirationDate: offerExpirationDate
    }
    if (currentStore == 0) {
        loyaltyObject.saveOffer(offerData, actionLink);
    }
    else {
        loyaltyObject.applyOffer(offerData, actionLink)
    }
}

function onClickPrint() {
    var {
        offerId, offertype, offerDescription, OfferTitle, countryLang
    } = getValues();

    var link = 'Print';
    var startOnlineOrder = 0;
    analytics.offerPrint(offerId, offertype, offerDescription, OfferTitle, countryLang, link, startOnlineOrder);
}

function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    switch (true) {
        case /windows phone/i.test(userAgent):
            return "Windows Phone";
        case /android/i.test(userAgent):
            return "Android";
        case /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream:
            return "iOS";
        case navigator.appVersion.indexOf("Win") != -1:
            return "Win";
        case navigator.appVersion.indexOf("Mac") != -1:
            return "Mac";
        default:
            return "unknown";
    }
}
const orderInApp = () => {
    var {
        offerId, offertype, offerDescription, OfferTitle, countryLang
    } = getValues();

    var link = 'order in app';
    var startOnlineOrder = 0;
    analytics.offerStart(offerId, offertype, offerDescription, OfferTitle, countryLang, link, startOnlineOrder);

    let os = getMobileOperatingSystem();

    switch (os) {
        case "iOS":
            window.location.href = $('#isoUrl').val();
            break;
        case "Android":
            window.location.href = $('#mobileUrl').val();
            break;
        case "Win":
            window.location.href = $('#desktopUrl').val();
        case "Mac":
            window.location.href = $('#desktopUrl').val();
            break
        default:
            window.location.href = $('#desktopUrl').val();
    }
}

function getValues() {
    var storeId = subwayScript.checkSatelliteNumber($('#hdnStoreId').val()) || "";
    var offerCode = $('#hdnPropositionGuid').val() || "";
    var offercampaignuri = $('#hdnOfferCampaignUri').val() || "";
    var offerId = $('#hdnOfferId').val() || "";
    var offertype = $('#hdnOfferType').val() ? $('#hdnOfferType').val().toLowerCase() : "";
    var offerDescription = $('#hdnOfferDescription').val() ? $('#hdnOfferDescription').val(): "";
    var offerExpirationDate = $('#hdnOfferExpirationDate').val() || "";
    var OfferTitle = $('#hdnOfferTitle').val() ? $('#hdnOfferTitle').val(): "";
    var countryLang = getDomainName()+$("#dtmPageName").val() ? getDomainName()+$("#dtmPageName").val().toLowerCase() : '';
    return {
        storeId, offerCode, offercampaignuri, offerExpirationDate, offerId, offertype, offerDescription, OfferTitle, countryLang
    }
}
